import _ from 'lodash';

export const getSoftwareProducts = state => state.customer.profile.softwareProducts;
export const getSoftwareProductsList = state => state.customer.profile.softwareProducts.productsList;
export const isLoading = state => state.customer.profile.softwareProducts.isLoading;